document.addEventListener('DOMContentLoaded', function () {
  const zipStateEl = document.getElementById('zip-state');
  const resultsStateEl = document.getElementById('results-state');

  const form = document.getElementById('zip-form');
  if (!form) return;

  const errorEl = document.getElementById('zone-error');

  const helperEl = document.getElementById('helper-dates');
  const adviceTitleEl = document.getElementById('advice-title');
  const adviceEl = document.getElementById('zone-advice');

  const zoneOut = document.getElementById('zone-output');
  const lastFrostOut = document.getElementById('last-frost-output');
  const firstFrostOut = document.getElementById('first-frost-output');

  // Email capture placeholders (we’re NOT wiring Klaviyo yet)
  const emailForm = document.getElementById('email-form');
  const emailStatus = document.getElementById('email-status');

  let zipData = null;

  fetch(window.ZIP_DATA_URL, { cache: 'no-store' })
    .then(res => {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    })
    .then(data => { zipData = data; })
    .catch(() => { zipData = null; });

  function formatDate(dateStr) {
    const d = new Date(dateStr + 'T00:00:00');
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  }

  function minusDaysFormatted(dateStr, days) {
    const d = new Date(dateStr + 'T00:00:00');
    d.setDate(d.getDate() - days);
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  }

  function setEmailStatus(msg) {
    if (!emailStatus) return;
    emailStatus.textContent = msg;
    emailStatus.style.display = 'block';
  }

  // Placeholder: no Klaviyo wiring yet
  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      setEmailStatus('Thanks! Email capture will be connected to Klaviyo next.');
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    const zip = document.getElementById('zip-input').value.trim();

    errorEl.style.display = 'none';
    helperEl.innerHTML = '';
    adviceTitleEl.textContent = '';
    adviceEl.innerHTML = '';
    if (emailStatus) emailStatus.style.display = 'none';

    if (!/^\d{5}$/.test(zip)) {
      errorEl.textContent = 'Please enter a valid 5-digit ZIP code.';
      errorEl.style.display = 'block';
      return;
    }

    if (!zipData) {
      errorEl.textContent = 'Data file did not load.';
      errorEl.style.display = 'block';
      return;
    }

    const info = zipData[zip];
    if (!info) {
      errorEl.textContent = 'ZIP code not found.';
      errorEl.style.display = 'block';
      return;
    }

    const zone = info.zone;
    const firstFrost = info.first_frost;
    const lastFrost = info.last_frost;

    zoneOut.textContent = zone;

    // Frost dates tucked at bottom
    firstFrostOut.textContent = formatDate(firstFrost);
    lastFrostOut.textContent = formatDate(lastFrost);

    const zoneNum = parseInt(zone, 10);

    // Planting window copy (updated to your rules)
    if (zoneNum >= 10) {
      helperEl.innerHTML =
        `<p><strong>When to start seeds:</strong> Start sweet pea seeds in <strong>November</strong> (fall).</p>
         <p><strong>Transplanting:</strong> Plant out when conditions are cool and plants are established.</p>`;
    } else if (zoneNum === 9) {
      const start6wFall = minusDaysFormatted(firstFrost, 42);
      const start4wFall = minusDaysFormatted(firstFrost, 28);
      const throughLastFrost = formatDate(lastFrost);

      helperEl.innerHTML =
        `<p><strong>When to start seeds (fall):</strong> Start between <strong>${start6wFall}</strong> and <strong>${start4wFall}</strong> (4–6 weeks before your first fall frost).</p>
         <p><strong>Spring option:</strong> You can start seeds right up <strong>through</strong> your last frost date: <strong>${throughLastFrost}</strong>.</p>
         <p><strong>Transplanting:</strong> Transplant once starts are large enough—about <strong>6-inch, bushy plants</strong>.</p>`;
    } else if (zoneNum === 8) {
  const fallStart = minusDaysFormatted(firstFrost, 28);
  const springStart = minusDaysFormatted(lastFrost, 42);

  helperEl.innerHTML =
    `<p><strong>Fall start:</strong> Start seeds around <strong>${fallStart}</strong> (about 4 weeks before first fall frost). Keep plants in pots (such as Rootrainers) in an unheated greenhouse or cold frame.</p>
     <p><strong>Spring start:</strong> Start seeds around <strong>${springStart}</strong> (about 6 weeks before last spring frost).</p>`;
} else if (zoneNum === 7) {
      helperEl.innerHTML =
        `<p><strong>When to start seeds:</strong> Start in <strong>late winter to early spring</strong>.</p>
         <p><strong>Transplanting:</strong> Plant out once the ground is workable and plants are established.</p>`;
    } else {
      // Zone 6 and below
      helperEl.innerHTML =
        `<p><strong>When to start seeds:</strong> Start about <strong>${minusDaysFormatted(lastFrost, 42)}</strong> (around 6 weeks before last spring frost).</p>
         <p><strong>Transplanting:</strong> Transplant when the ground is workable and plants are big enough.</p>`;
    }

    // Zone advice placeholders
    const adviceMap = {
      7: 'zone 7 advice to go here',
      8: 'zone 8 advice to go here',
      9: 'zone 9 advice to go here',
      10: 'zone 10 advice to go here'
    };

    adviceTitleEl.textContent = `What gardeners in Zone ${zoneNum} should know`;
    if (adviceMap[zoneNum]) {
      adviceEl.innerHTML = `<p>${adviceMap[zoneNum]}</p>`;
    } else {
      adviceEl.innerHTML = `<p>Zone-specific advice will be added here.</p>`;
    }

    // Swap states: hide form, show results
    zipStateEl.style.display = 'none';
    resultsStateEl.style.display = 'block';
  });
});
